export interface TopBannerProps {
  url: string;
  highResUrl: string;
  mobileUrl: string;
  mobileHighResUrl: string;
}

export const TopBanner = (props: TopBannerProps) => {
  return (
    <picture>
      <source media="(max-width: 639px)" srcSet={`${props.mobileUrl} 1x, ${props.mobileHighResUrl} 2x`} />
      <img
        src={props.url}
        srcSet={`${props.url} 1x, ${props.highResUrl} 2x`}
        className="max-h-none md:max-h-[200px] object-fill w-full"
        alt="Firm banner"
      />
    </picture>
  );
};
